import { CurationDashboardComponent } from './components/curation-dashboard/curation-dashboard.component';
import { AddAberrationComponent } from './components/add-aberration/add-aberration.component';
import { CurationService } from './services/curation.service';
import { CurationActionCreatorService } from './services/curation-action-creator.service';
import { CurationEditorAberrationComponent } from './components/curation-editor/aberration/curation-editor-aberration.component';
import { CurationMatchFoundComponent } from './components/curation-match-found/curation-match-found.component';
import { CurationEditorActionsComponent } from './components/curation-editor/curation-editor-actions/curation-editor-actions.component';
import { CurationUtils } from './utils/curation-utils';
import { CurationEditorHeaderComponent } from './components/curation-editor/curation-editor-header/curation-editor-header.component';
import { CurationCloningSelectionComponent } from './components/curation-dashboard/curation-cloning-selection/curation-cloning-selection.component';
import { HistoryComponent } from '../shared/components/history/history.component';
import { HistoryActionsComponent } from '../shared/components/history/history-actions/history-actions.component';
import { HistoryTableComponent } from '../shared/components/history/history-table/history-table.component';
import { CurationEditorAberrationDataComponent } from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-aberration-data.component';
import { CurationEditorAberrationDetailsComponent } from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-aberration-details/curation-editor-aberration-details.component';
import { CurationEditorItemComponent } from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-item/curation-editor-item.component';
import { CurationEditorSummaryComponent } from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-summary/curation-editor-summary.component';
import { CurationEditorItemsContainerComponent } from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-items-container/curation-editor-items-container.component';
import { curationDashboardAberrationService } from './components/curation-dashboard/services/curation-dashboard-aberration-service';
import { curationDashboardPathwaysService } from './components/curation-dashboard/services/curation-dashboard-pathways-service';
import { curationDashboardClinicalTrialService } from './components/curation-dashboard/services/curation-dashboard-clinicaltrials-service';
import { curationDashboardWorklistService } from './components/curation-dashboard/services/curation-dashboard-worklist-service';
import { CurationFilterContainerComponent } from './components/curation-filter/curation-filter-container.component';
import { AddCurationComponent } from './components/add-curation/add-curation.component';
import { ClinicalTrialMatchService } from './services/clinical-trial-match.service';
import { CurationEditorRegimenComponent } from './components/curation-editor/regimen/curation-editor-regimen.component';
import { CurationEditorPlacementComponent } from './components/curation-editor/placement/curation-editor-placement.component';
import { CurationEditorTreatmentProtocolComponent } from './components/curation-editor/treatmentprotocol/curation-editor-treatmentprotocol.component';
import { ExternalSearchService } from '../shared/services/external-search.service';
import { CurationEditorActionMessageComponent } from './components/curation-editor/curation-editor-action-message/curation-editor-action-message.component';
import { curationDashboardPlacementService } from './components/curation-dashboard/services/curation-dashboard-placement-service';
import { CurationItemNotFoundComponent } from './components/curation-item-not-found/curation-item-not-found.component';
import { CurationModalMessageComponent } from './components/curation-dashboard/curation-modal-message/curation-modal-message.component';
import { PathwayJsonTreeConverterService } from './services/pathway-json-tree-converter.service';
import {TreatmentPlanRichNotesWidgetComponent} from "./components/curation-editor/treatmentplan/widgets/treatment-plan-notes/treatment-plan-notes.component";
import { NodesPlaceViewCalculationsService } from './services/nodes-place-view-calculations.service';

export const curationComponents = [
  CurationDashboardComponent,
  AddAberrationComponent,
  CurationEditorAberrationComponent,
  CurationEditorRegimenComponent,
  CurationEditorPlacementComponent,
  CurationMatchFoundComponent,
  CurationItemNotFoundComponent,
  CurationEditorAberrationDataComponent,
  CurationEditorAberrationDetailsComponent,
  CurationEditorItemComponent,
  CurationEditorSummaryComponent,
  CurationEditorTreatmentProtocolComponent,
  CurationEditorActionsComponent,
  CurationEditorHeaderComponent,
  CurationEditorActionMessageComponent,
  CurationCloningSelectionComponent,
  CurationFilterContainerComponent,
  HistoryComponent,
  HistoryActionsComponent,
  HistoryTableComponent,
  CurationEditorItemsContainerComponent,
  AddCurationComponent,
  CurationModalMessageComponent,
  TreatmentPlanRichNotesWidgetComponent
];
export const curationServices = [
  CurationService,
  CurationActionCreatorService,
  curationDashboardAberrationService,
  curationDashboardPathwaysService,
  curationDashboardWorklistService,
  ExternalSearchService,
  ClinicalTrialMatchService,
  curationDashboardClinicalTrialService,
  curationDashboardPlacementService,
  PathwayJsonTreeConverterService,
  NodesPlaceViewCalculationsService
];
export const curationUtils = [CurationUtils];
